import * as TeamblogActionTypes from '../../../constants/setting/TeamblogActionTypes';
import update from 'immutability-helper'

const initialState = {
    items: [],
    totalCount: null,
	waitingMembers: [],
};

const itemUpdate = (items, id, values) => items.map(item => {
	if (item.id === id) {
		item = Object.assign({}, item, values)
	}
	return item
})

const updatedItems = (state, id, values) => Object.assign({}, state, {
	items: itemUpdate(state.items, id, values)
})

const selectedItems = (items, id, select) => items.map(item => {
    if (item.id === id) {
        item = Object.assign({}, item, { selected: select })
    }
    return item
});

export default (state = initialState, action) => {
	switch (action.type) {
		case TeamblogActionTypes.CLEAR_ITEMS:
            return Object.assign({}, state, {
                items: [],
                totalCount: null,
                waitingMembers: [],
            });
		case TeamblogActionTypes.RECEIVE_ITEMS:
            return Object.assign({}, state, {
                items: action.items,
                totalCount: action.totalCount
            });
		case TeamblogActionTypes.SELECT_ITEM:
			return updatedItems(state, action.id, { selected: true })

		case TeamblogActionTypes.DESELECT_ITEM:
			return updatedItems(state, action.id, { selected: false })

		case TeamblogActionTypes.SELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if ( item.editable) {
                    	item = Object.assign({}, item, { selected: true })
                    }
					return item
				})
			})
		case TeamblogActionTypes.DESELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => Object.assign({}, item, { selected: false }) )
			})
		case TeamblogActionTypes.UPDATE_ITEM:
			return updatedItems(state, action.item.id, action.item)

		case TeamblogActionTypes.UPDATE_SELECTED_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if (item.selected) {
						item = Object.assign({}, item, action.values)
					}
					return item
				})
			})
		case TeamblogActionTypes.RECEIVE_WAITING_ITEMS:
            return update(state, {
                waitingMembers: {
                    $set: action.items,
                }
            });
	}
	return state
}
